<template>
    <div>
        <h1>{{ $t('setup.finished.header') }}</h1>
        <div class="ct-card">
            <section class="top-margin">
                <div
                    class="ct-text"
                    v-html="
                        information.withWebsite && information.cta && information.cta.startsWith('cwb')
                            ? $t('setup.finished.descriptionWebsite')
                            : $t('setup.finished.description', {
                                  email: information.email,
                                  siteName: information.siteName
                              })
                    "
                ></div>
            </section>
            <section class="ct-action">
                <div class="ct-input-element">
                    <a :href="siteUrl" class="btn btn-primary btn-lg btn-block">{{ $t('setup.finished.login') }}</a>
                </div>
                <img
                    v-if="information.country === 'DE'"
                    height="1"
                    width="1"
                    style="border-style:none;"
                    alt=""
                    src="//www.googleadservices.com/pagead/conversion/860296234/?label=uk81CJqN5HEQqqicmgM&amp;guid=ON&amp;script=0"
                />
                <img
                    v-else-if="information.country === 'GB'"
                    height="1"
                    width="1"
                    style="border-style:none;"
                    alt=""
                    src="//www.googleadservices.com/pagead/conversion/860296234/?label=A7y4CLOU5HEQqqicmgM&amp;guid=ON&amp;script=0"
                />
                <img
                    v-else-if="information.country === 'BR'"
                    height="1"
                    width="1"
                    style="border-style:none;"
                    alt=""
                    src="//www.googleadservices.com/pagead/conversion/860296234/?label=A7y4CLOU5HEQqqicmgM&amp;guid=ON&amp;script=0"
                />
                <img
                    v-else
                    height="1"
                    width="1"
                    style="border-style:none;"
                    alt=""
                    src="//www.googleadservices.com/pagead/conversion/860296234/?label=A7y4CLOU5HEQqqicmgM&amp;guid=ON&amp;script=0"
                />
            </section>
        </div>
    </div>
</template>
<script>
import * as types from '../store/mutation-types';

export default {
    data: function() {
        return {};
    },
    mounted() {
        if (typeof this.$route.params.token !== 'undefined' && this.$route.params.token !== '') {
            this.$store.dispatch('registrations/loadRegistration', { token: this.$route.params.token });
        }
    },
    computed: {
        information: function() {
            return this.$store.getters['registrations/registerInformation'];
        },
        siteUrl: function() {
            console.dir(this.information);
            if (this.information.withWebsite && this.information.cta && this.information.cta.startsWith('cwb')) {
                return 'https://' + this.information.siteName + '.dev.churchtools.website/admin';
            }
            return 'https://' + this.information.siteName + (this.information.inKRZ ? '.krz' : '.church') + '.tools';
        }
    }
};
</script>
